import { ErrorCode, GenericResponseSecuritySearchResponse, Security } from '@blk/wealth-web-endpoint';
import * as get from 'lodash/get';

import { mapSecurityToWweSecurity } from './security-response-mappings';

export const mapSecuritySearchResponseToWweSecurityList = (response: GenericResponseSecuritySearchResponse) => {
	if (response.success) {
		return get(response, 'resultList[0].securities', []).map((security: Security) => {
			return mapSecurityToWweSecurity(security);
		});
	} else {
		const errors = Object.keys(response.errorCodes).map(key => response.errorCodes[key]);
		handleSecuritySearchErrors(errors);
	}
};

export const mapSecuritySearchResponseToFacetFields = (response: GenericResponseSecuritySearchResponse) => {
	if (response.success) {
		return get(response, 'resultList[0].facetFields', []);
	} else {
		const errors = Object.keys(response.errorCodes).map(key => response.errorCodes[key]);
		handleSecuritySearchErrors(errors);
	}
};

function handleSecuritySearchErrors(errorList: ErrorCode[]): Error {
	// TODO Properly handle errors here. This hard-coded string is fine for now!
	throw new Error('Security Search Response Error');
}

